import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MediaFolder, Error, FolderDialogData } from 'src/app/utils/common-classes';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FolderService } from 'src/app/services/Folder/folder.service';
import { UtilsService } from 'src/app/services/Utils/utils.service';

@Component({
  selector: 'app-create-folder-dialog',
  templateUrl: './create-folder-dialog.component.html',
  styleUrls: ['./create-folder-dialog.component.scss']
})
export class CreateFolderDialogComponent implements OnInit {
  public form: FormGroup;
  public createFolderError: string;
  public formSubmitAttempt: boolean;

  constructor(
    public dialogRef: MatDialogRef<CreateFolderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FolderDialogData,
    private fb: FormBuilder,
    private folderService: FolderService,
    public utils: UtilsService) { }

  ngOnInit() {
    this.form = this.fb.group({
      folderName: ['', [Validators.required, Validators.pattern('^[^\\/?%*:|"<>\.]+$')]]
    });
  }

  public onSubmit(): void {
    let _self = this;
    _self.formSubmitAttempt = true;
    if (_self.form.valid) {
      let folderName = _self.form.get('folderName').value;
      _self.utils.showShortLoader();
      _self.folderService.createFolder(folderName, _self.data.node ? _self.data.node.mediaFolderId : null, _self.data.mediaTree.mediaTreeId).then((newFolder: MediaFolder) => {
        _self.dialogRef.close(newFolder);
      }).catch((err) => {
        return _self.utils.getError(err);
      }).then((translatedError) => {
        if (translatedError) {
          _self.createFolderError = translatedError;
        }
      }).finally(() => {
        _self.utils.hideShortLoader();
      });
    }
  }

}
